import type { FC } from "react";
import CheckboxInput from "../../../../../../components/checkbox-input/checkbox-input";
import Input from "../../../../../../components/input/input";
import * as CSS from "./updates-social.styles";

type UpdatesSocialProps = {
	blueSky: boolean;
	onBlueSkyChange: (checked: boolean) => void;
	postToX: boolean;
	onPostToXChange: (checked: boolean) => void;
	hashtags: string;
	onHashtagsChange: (value: string) => void;
};

const UpdatesSocial: FC<UpdatesSocialProps> = ({
	blueSky,
	onBlueSkyChange,
	postToX,
	onPostToXChange,
	hashtags,
	onHashtagsChange,
}) => {
	return (
		<CSS.UpdatesSocial>
			<CSS.SocialCheckboxes>
				<CheckboxInput
					id="bluesky"
					label="Post to Bluesky"
					checked={blueSky}
					onCheck={() => onBlueSkyChange(!blueSky)}
				/>
				<CheckboxInput
					id="x"
					label="Post to X (will open a popup)"
					checked={postToX}
					onCheck={() => onPostToXChange(!postToX)}
				/>
			</CSS.SocialCheckboxes>
			<Input
				placeholder="Hashtags (comma seperated)"
				value={hashtags}
				onChange={(e) => onHashtagsChange(e.target.value)}
				disabled={!blueSky && !postToX}
			/>
		</CSS.UpdatesSocial>
	);
};

export default UpdatesSocial;
